import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.array.find-index";
import "core-js/modules/web.dom.iterable";
import _defineProperty from "D:/java/\u4E00\u7F51\u901A\u529E(\u529E\u4E8B\u5927\u53852.0)/\u4E00\u7F51\u901A\u529E\u524D\u7AEFPC/pc/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import card from "@/components/management/showcase/card";
import subject from "@/components/management/showcase/subject";
import subjectdl from "@/components/management/showcase/subjectdl";
import topic from "@/components/management/showcase/topic";
import topicdl from "@/components/management/showcase/topicdl";
import tinfoLink from "@/components/management/showcase/tinfoLink";
import home from "@/components/management/showcase/home";
import linkMaga from "@/components/management/showcase/linkMaga";
import linkMagaC from "@/components/management/showcase/childModules/linkMagaC";
import homeC from "@/components/management/showcase/childModules/homeC";
import tinfoLinkC from "@/components/management/showcase/childModules/tinfoLinkC";
import cardC from "@/components/management/showcase/childModules/cardC";
import topicC from "@/components/management/showcase/childModules/topicC";
import subjectC from "@/components/management/showcase/childModules/subjectC";
import SchoolDateC from "@/components/management/showcase/childModules/SchoolDate";
import draggable from "vuedraggable";
import { getNavigationList as _getNavigationList, getTopicCatalogList as _getTopicCatalogList, getSubjectCatalogList as _getSubjectCatalogList, savePageDeskVo, getServeCommentList as _getServeCommentList, getCalendar } from "@/api/management/showcase";
import { tableList, getNoticeList as _getNoticeList } from "@/api/portrayal/policy";
import request from "@/util/http";
import { mapGetters, mapActions } from "vuex";
export default {
  name: "showcaseConfig",
  components: {
    draggable: draggable,
    card: card,
    subject: subject,
    subjectdl: subjectdl,
    topic: topic,
    topicdl: topicdl,
    tinfoLink: tinfoLink,
    home: home,
    homeC: homeC,
    tinfoLinkC: tinfoLinkC,
    cardC: cardC,
    topicC: topicC,
    subjectC: subjectC,
    SchoolDateC: SchoolDateC,
    linkMaga: linkMaga,
    linkMagaC: linkMagaC
  },
  props: ["showcaseConfigData"],
  data: function data() {
    return {
      loading: false,
      moduleTree: [{
        label: "首页",
        component: "home",
        code: "HOME",
        children: [{
          label: "卡片",
          component: "card",
          code: "CARD"
        }, // {
        //   label: "主题",
        //   component: "subject",
        //   code: 'SUBJECT',
        // },
        {
          label: "专题",
          component: "topic",
          code: "TOPIC"
        }, {
          label: "信息导航",
          component: "tinfoLink",
          code: "LINK"
        }, {
          label: "信息发布管理",
          component: "linkMaga",
          code: "LINKMAGA"
        }]
      }],
      defaultProps: {
        children: "children",
        label: "label"
      },
      childModules: [],
      activeModule: {
        component: "home"
      },
      navigationList: [],
      topicCatalogList: [],
      subjectCatalogList: [],
      fileList: [],
      //校内公文
      rulesList: [],
      //规章制度
      businessList: [],
      //业务流程
      downloadList: [],
      //常用下载
      noticeList: [],
      //通知公告
      CalendarList: {},
      //校历周数据
      nodeList: {},
      //便签数据
      schList: {},
      //日程数据
      affairList: {},
      //事务数据
      ServeCommentData: {},
      changed: false,
      homeModules: [],
      saving: false
    };
  },
  created: function created() {
    this.getChildModules();
    this.getLaunchData(); // this.getCalendarList()
  },
  computed: _objectSpread({}, mapGetters(["moduleList"])),
  watch: {},
  methods: {
    closeShowcaseConfig: function closeShowcaseConfig() {
      var _this = this;

      if (this.changed) {
        this.$confirm("是否确认放弃修改并关闭页面?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).then(function () {
          _this.$emit("closeShowcaseConfig");
        });
      } else {
        this.$emit("closeShowcaseConfig");
      }
    },
    handleNodeClick: function handleNodeClick(e) {
      var _this2 = this;

      var included = this.moduleList.some(function (item) {
        return item.cardType === e.code;
      });

      if (!included && e.code !== "HOME") {
        this.$alert("\u6CA1\u6709\u6DFB\u52A0".concat(e.label, "\u6A21\u5757,\u82E5\u8981\u7F16\u8F91\u8BE5\u6A21\u5757\u8BF7\u5148\u6DFB\u52A0\u81F3\u9996\u9875"), "提示");
        return;
      }

      if (this.changed && e.component !== this.activeModule.component) {
        this.$confirm("当前页面尚未保存,切换页面会丢失修改的数据,是否确定继续切换页面?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).then(function () {
          _this2.homeModules = JSON.parse(JSON.stringify(_this2.moduleList)); // 还原修改

          _this2.changed = false;
          _this2.activeModule = e;

          _this2.getChildModules();
        });
      } else {
        this.activeModule = e;
        this.getChildModules();
      }
    },
    getChildModules: function getChildModules() {
      if (this.activeModule.component === "home") {
        this.childModules = [{
          id: 1,
          name: "卡片",
          code: "CARD"
        }, {
          id: 2,
          name: "主题",
          code: "SUBJECT"
        }, {
          id: 3,
          name: "专题",
          code: "TOPIC"
        }, {
          id: 4,
          name: "服务评价",
          code: "COMMENT"
        }, {
          id: 5,
          name: "信息导航",
          code: "LINK"
        }, {
          id: 6,
          name: "信息发布管理",
          code: "LINKMAGA"
        }, {
          id: 7,
          name: "应用中心",
          code: "SUBJECTDL"
        }, {
          id: 8,
          name: "办事服务",
          code: "TOPICDL"
        }];
      } else if (this.activeModule.component === "tinfoLink") {
        this.childModules = this.navigationList;
      } else if (this.activeModule.component === "card") {
        this.childModules = [{
          title: "通知公告",
          code: "TINFO_NOTICE",
          type: "LIST",
          pos: 0,
          len: 5,
          data: this.noticeList,
          col: 1,
          row: 1,
          dataConfig: ""
        }, {
          title: "校内公文",
          code: "TINFO_POLICY_FILE",
          type: "LIST",
          pos: 0,
          len: 5,
          data: this.fileList,
          col: 1,
          row: 1,
          dataConfig: ""
        }, {
          title: "校历",
          code: "TINFO_CALENDAR",
          type: "LIST",
          pos: 0,
          len: 8,
          data: this.CalendarList,
          col: 1,
          row: 1,
          dataConfig: ""
        }, {
          title: "便签",
          code: "TINFO_LABLE",
          type: "LIST",
          pos: 0,
          len: 8,
          data: this.nodeList,
          col: 1,
          row: 1,
          dataConfig: ""
        }, {
          title: "日程",
          code: "TINFO_SCHEDULE",
          type: "LIST",
          pos: 0,
          len: 8,
          data: this.schList,
          col: 1,
          row: 1,
          dataConfig: ""
        }, {
          title: "我的事务",
          code: "TINFO_AFFAIR",
          type: "LIST",
          pos: 0,
          len: 8,
          data: this.affairList,
          col: 1,
          row: 1,
          dataConfig: ""
        }];
      } else if (this.activeModule.component === "topic") {
        this.childModules = this.topicCatalogList;
      } else if (this.activeModule.component === "subject") {
        this.childModules = this.subjectCatalogList;
      } else if (this.activeModule.component === "linkMaga") {
        this.childModules = [{
          title: "规章制度",
          code: "TINFO_RULES",
          type: "LIST",
          pos: 0,
          len: 5,
          data: [],
          col: 3,
          row: 1,
          dataConfig: ""
        }, {
          title: "业务流程",
          code: "TINFO_BUSINESS",
          type: "LIST",
          pos: 0,
          len: 5,
          data: [],
          col: 3,
          row: 1,
          dataConfig: ""
        }, {
          title: "常用下载",
          code: "TINFO_DOWNLOAD",
          type: "LIST",
          pos: 0,
          len: 5,
          data: [],
          col: 3,
          row: 1,
          dataConfig: ""
        }];
      } else {
        this.childModules = [];
      }
    },
    getNavigationList: function getNavigationList() {
      return _getNavigationList({
        len: 100,
        pos: 0
      });
    },
    getTopicCatalogList: function getTopicCatalogList() {
      return _getTopicCatalogList({
        len: 100,
        pos: 0
      });
    },
    getSubjectCatalogList: function getSubjectCatalogList() {
      return _getSubjectCatalogList({
        len: 100,
        pos: 0
      });
    },
    getServeCommentList: function getServeCommentList() {
      return _getServeCommentList();
    },
    //获取校历周
    // getCalendarList(){
    //     getCalendar().then(({data}) =>{
    //         this.CalendarList = data.data
    //     })
    // },
    getTableList: function getTableList() {
      return tableList({
        current: 1,
        size: 5
      });
    },
    getNoticeList: function getNoticeList() {
      return _getNoticeList({
        pos: 0,
        len: 5
      });
    },
    //各模块接口
    getLaunchData: function getLaunchData() {
      var _this3 = this;

      this.loading = true;
      request.all([this.getNavigationList(), this.getTopicCatalogList(), this.getSubjectCatalogList(), this.getServeCommentList(), this.getTableList(), this.getNoticeList()]).then(function (res) {
        res.forEach(function (item, index) {
          if (item.data.code !== 0) {
            _this3.$message.error(item.data.msg);
          } else {
            switch (index) {
              case 0:
                _this3.navigationList = item.data.data;
                break;

              case 1:
                _this3.topicCatalogList = item.data.data;
                break;

              case 2:
                _this3.subjectCatalogList = item.data.data;
                break;

              case 3:
                _this3.ServeCommentData = item.data.data;
                break;

              case 4:
                var arr = [];
                item.data.data.records.forEach(function (item) {
                  var data = {};
                  data.fiDate = item.createTime.substring(item.createTime.indexOf("-") + 1, item.createTime.indexOf(" "));
                  data.fiTitle = item.title;
                  data.fiId = item.id;
                  arr.push(data);
                });
                _this3.fileList = arr;
                break;

              case 5:
                _this3.noticeList = item.data.data;
                break;
            }
          }
        });
      }).finally(function () {
        _this3.loading = false;
      });
    },
    selectedChange: function selectedChange(data) {
      var _this4 = this;

      switch (data.module) {
        case "home":
          var arr = [];
          data.data.forEach(function (item) {
            var exist = _this4.moduleList.some(function (element) {
              return element.cardType === item.code;
            });

            if (exist) {
              _this4.moduleList.forEach(function (element) {
                if (element.cardType === item.code) {
                  arr.push(JSON.parse(JSON.stringify(element)));
                }
              });
            } else {
              var newItem = {};

              switch (item.code) {
                case "CARD":
                  newItem = {
                    cardType: "CARD",
                    cardCol: 2,
                    cardRow: 1,
                    dataConfig: null,
                    cardModules: [{
                      title: "通知公告",
                      code: "TINFO_NOTICE",
                      type: "LIST",
                      pos: 0,
                      len: 8,
                      data: _this4.noticeList,
                      col: 1,
                      row: 1,
                      dataConfig: ""
                    }, {
                      title: "校内公文",
                      code: "TINFO_POLICY_FILE",
                      type: "LIST",
                      pos: 0,
                      len: 8,
                      data: _this4.fileList,
                      col: 1,
                      row: 1,
                      dataConfig: ""
                    }, {
                      title: "校历",
                      code: "TINFO_CALENDAR",
                      type: "LIST",
                      pos: 0,
                      len: 8,
                      data: _this4.CalendarList,
                      col: 1,
                      row: 1,
                      dataConfig: ""
                    }, {
                      title: "便签",
                      code: "TINFO_LABLE",
                      type: "LIST",
                      pos: 0,
                      len: 8,
                      data: _this4.nodeList,
                      col: 1,
                      row: 1,
                      dataConfig: ""
                    }, {
                      title: "日程",
                      code: "TINFO_SCHEDULE",
                      type: "LIST",
                      pos: 0,
                      len: 8,
                      data: _this4.schList,
                      col: 1,
                      row: 1,
                      dataConfig: ""
                    }, {
                      title: "我的事务",
                      code: "TINFO_AFFAIR",
                      type: "LIST",
                      pos: 0,
                      len: 8,
                      data: _this4.affairList,
                      col: 1,
                      row: 1,
                      dataConfig: ""
                    }]
                  };
                  break;

                case "SUBJECT":
                  newItem = {
                    cardType: "SUBJECT",
                    cardCol: 1,
                    cardRow: 1,
                    dataConfig: null,
                    cardModules: [{
                      title: "主题分类模块",
                      code: "TSER_SUBJECT",
                      type: "LIST",
                      pos: 0,
                      len: 8,
                      data: _this4.subjectCatalogList,
                      col: 1,
                      row: 1,
                      dataConfig: ""
                    }]
                  };
                  break;

                case "SUBJECTDL":
                  newItem = {
                    cardType: "SUBJECTDL",
                    cardCol: 1,
                    cardRow: 1,
                    dataConfig: null,
                    cardModules: [{
                      title: "应用中心",
                      code: "TSER_SUBJECTDL",
                      type: "LIST",
                      pos: 0,
                      len: 8,
                      data: _this4.subjectCatalogList,
                      col: 1,
                      row: 1,
                      dataConfig: ""
                    }]
                  };
                  break;

                case "TOPIC":
                  newItem = {
                    cardType: "TOPIC",
                    cardCol: 1,
                    cardRow: 1,
                    dataConfig: null,
                    cardModules: [{
                      title: "专题分类模块",
                      code: "TSER_TOPIC",
                      type: "LIST",
                      pos: 0,
                      len: 8,
                      data: _this4.topicCatalogList,
                      col: 4,
                      row: 1,
                      dataConfig: ""
                    }]
                  };
                  break;

                case "TOPICDL":
                  newItem = {
                    cardType: "TOPICDL",
                    cardCol: 1,
                    cardRow: 1,
                    dataConfig: null,
                    cardModules: [{
                      title: "办事服务",
                      code: "TSER_TOPICDL",
                      type: "LIST",
                      pos: 0,
                      len: 8,
                      data: _this4.topicCatalogList,
                      col: 4,
                      row: 1,
                      dataConfig: ""
                    }]
                  };
                  break;

                case "COMMENT":
                  newItem = {
                    cardType: "COMMENT",
                    cardCol: 1,
                    cardRow: 1,
                    dataConfig: null,
                    cardModules: [{
                      title: "服务评价模块",
                      code: "TSER_COMMENT",
                      type: "DETAIL",
                      pos: 0,
                      len: 8,
                      data: _this4.ServeCommentData,
                      col: 1,
                      row: 1,
                      dataConfig: ""
                    }]
                  };
                  break;

                case "LINK":
                  newItem = {
                    cardType: "LINK",
                    cardCol: 1,
                    cardRow: 1,
                    dataConfig: null,
                    cardModules: [{
                      title: "信息导航模块",
                      code: "TINFO_LINK",
                      type: "LIST",
                      pos: 0,
                      len: 8,
                      data: _this4.navigationList,
                      col: 5,
                      row: 1,
                      dataConfig: ""
                    }]
                  };
                  break;

                case "LINKMAGA":
                  newItem = {
                    cardType: "LINKMAGA",
                    cardCol: 3,
                    cardRow: 1,
                    dataConfig: null,
                    cardModules: [{
                      title: "规章制度",
                      code: "TINFO_RULES",
                      type: "LIST",
                      pos: 0,
                      len: 5,
                      data: [],
                      col: 3,
                      row: 1,
                      dataConfig: ""
                    }, {
                      title: "业务流程",
                      code: "TINFO_BUSINESS",
                      type: "LIST",
                      pos: 0,
                      len: 5,
                      data: [],
                      col: 3,
                      row: 1,
                      dataConfig: ""
                    }, {
                      title: "常用下载",
                      code: "TINFO_DOWNLOAD",
                      type: "LIST",
                      pos: 0,
                      len: 5,
                      data: [],
                      col: 3,
                      row: 1,
                      dataConfig: ""
                    }]
                  };
                  break;
              }

              arr.push(newItem);
            }
          });
          this.homeModules = arr; // this.$store.commit('setModuleList', arr)

          break;

        case "card":
          var carIindex = this.homeModules.findIndex(function (item) {
            return item.cardType === "CARD";
          });

          if (carIindex > -1) {
            this.homeModules[carIindex].cardModules = data.data;
            this.homeModules[carIindex].cardCol = data.col;
            this.$set(this.homeModules, carIindex, this.homeModules[carIindex]);
          }

          break;

        case "linkMaga":
          var linkMagaIindex = this.homeModules.findIndex(function (item) {
            return item.cardType === "LINKMAGA";
          });

          if (linkMagaIindex > -1) {
            this.homeModules[linkMagaIindex].cardModules = data.data;
            this.homeModules[linkMagaIindex].cardCol = data.col;
            this.$set(this.homeModules, linkMagaIindex, this.homeModules[linkMagaIindex]);
          }

          break;

        case "topic":
          var topicIndex = this.homeModules.findIndex(function (item) {
            return item.cardType === "TOPIC";
          });

          if (topicIndex > -1) {
            this.homeModules[topicIndex].cardModules[0].data = data.data;
            this.homeModules[topicIndex].cardModules[0].col = data.col;
            this.$set(this.homeModules, topicIndex, this.homeModules[topicIndex]);
          }

          break;

        case "topicdl":
          var topicdlIndex = this.homeModules.findIndex(function (item) {
            return item.cardType === "TOPICDL";
          });

          if (topicIndex > -1) {
            this.homeModules[topicdlIndex].cardModules[0].data = data.data;
            this.homeModules[topicdlIndex].cardModules[0].col = data.col;
            this.$set(this.homeModules, topicdlIndex, this.homeModules[topicdlIndex]);
          }

          break;

        case "subjectdl":
          var subjectdlIndex = this.homeModules.findIndex(function (item) {
            return item.cardType === "SUBJECTDL";
          });

          if (subjectdlIndex > -1) {
            this.homeModules[subjectdlIndex].cardModules[0].data = data.data;
            this.homeModules[subjectdlIndex].cardModules[0].col = data.col;
            this.$set(this.homeModules, subjectdlIndex, this.homeModules[subjectdlIndex]);
          }

          break;

        case "tinfoLink":
          var linkIndex = this.homeModules.findIndex(function (item) {
            return item.cardType === "LINK";
          });

          if (linkIndex > -1) {
            this.homeModules[linkIndex].cardModules[0].data = data.data;
            this.homeModules[linkIndex].cardModules[0].col = data.col;
            this.$set(this.homeModules, linkIndex, this.homeModules[linkIndex]);
          }

          break;
      }
    },
    saveConfig: function saveConfig() {
      var _this5 = this;

      // 判断子模块不能为空
      var isEmpty = this.$refs[this.activeModule.component].isEmpty();

      if (isEmpty) {
        this.$message.warning("子模块不能为空");
        return;
      }

      var obj = {
        cards: this.homeModules,
        deskDes: null,
        deskId: this.showcaseConfigData.deskId || "",
        deskType: this.showcaseConfigData.deskType
      };
      this.saving = true;
      savePageDeskVo(obj).then(function (_ref) {
        var data = _ref.data;

        if (data.code == 0) {
          _this5.$message.success("保存成功");

          if (_this5.showcaseConfigData.deskId) {
            _this5.$store.dispatch("getPageDeskVo", _this5.showcaseConfigData.deskId);
          }

          _this5.changed = false;
        } else {
          _this5.$message.error(data.msg);
        }
      }).finally(function () {
        _this5.saving = false;
      });
    },
    addClick: function addClick(data) {
      this.$refs[this.activeModule.component].addButton(data);
    },
    caseChanged: function caseChanged(bol) {
      this.changed = bol;
    }
  }
};